import { render, staticRenderFns } from "./ResearchProfileCreate.vue?vue&type=template&id=37f35135&scoped=true&"
import script from "./ResearchProfileCreate.vue?vue&type=script&lang=js&"
export * from "./ResearchProfileCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f35135",
  null
  
)

export default component.exports